import React from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { sortRoleIdsByPosition } from 'components/helpers/personnel';

export default function UserCompanyRolesList({
  assignableRolesCollection,
  currentPersonnel,
  onRemoveRole,
  onSelectPrimary,
}) {
  const { t: i18nT } = useTranslation('components', {
    keyPrefix: 'personnel.UserCompanyRolesList',
  });

  const roleIds = sortRoleIdsByPosition(
    assignableRolesCollection,
    currentPersonnel.companyRoleIds,
  );

  return (
    <>
      {roleIds.map((id) => {
        const role = assignableRolesCollection.find((ar) => ar.id === id);

        const isPrimaryCompanyRoleId =
          currentPersonnel.primaryCompanyRoleId === id;

        return (
          <div
            className='tw-group/pill chip-item-pill tw-mb-2 tw-inline-flex tw-w-full tw-items-center tw-justify-between tw-overflow-hidden tw-rounded-md tw-bg-grey-050 tw-px-3 tw-py-2.5'
            key={id}
          >
            <div className='tw-relative tw-mr-2 tw-inline-flex tw-flex-grow tw-items-center tw-justify-between'>
              <span className='tw-text-s tw-font-medium tw-tracking-wide'>
                {role ? role.attributes.position : ''}
              </span>
              {isPrimaryCompanyRoleId ?
                <span className='tw-flex-shrink-0 tw-text-s tw-tracking-wide tw-text-grey-500'>
                  {roleIds.length > 1 && i18nT('primaryRole')}
                </span>
              : <div
                  className='chip-item-pill__action tw-absolute tw-bottom-0 tw-right-0 tw-top-0 tw-hidden tw-flex-shrink-0 tw-cursor-pointer tw-flex-col tw-justify-center tw-bg-gradient-to-r tw-from-transparent tw-from-0% tw-to-grey-050 tw-to-[26px] tw-pl-6 tw-align-baseline tw-text-s tw-tracking-wide tw-text-blue-500 hover:tw-text-blue-300 active:tw-text-blue-300 group-hover/pill:tw-flex'
                  onClick={() => onSelectPrimary(id)}
                >
                  {i18nT('setAsPrimary')}
                </div>
              }
            </div>
            <span
              className="collection-select__multivalue-remove circle--remove tw-ml-2 tw-bg-transparent before:tw-bg-grey-700 before:tw-content-[''] after:tw-bg-grey-700 after:tw-content-[''] hover:tw-bg-red-600 hover:before:tw-bg-white hover:after:tw-bg-white"
              onClick={() => onRemoveRole(id)}
            />
          </div>
        );
      })}
    </>
  );
}

UserCompanyRolesList.propTypes = {
  currentPersonnel: PropTypes.object.isRequired,
  assignableRolesCollection: PropTypes.array.isRequired,
  onSelectPrimary: PropTypes.func.isRequired,
  onRemoveRole: PropTypes.func.isRequired,
};
